__turbopack_context__.v({
  "closeBtn": "styles-module__skWmJW__closeBtn",
  "container": "styles-module__skWmJW__container",
  "description": "styles-module__skWmJW__description",
  "form": "styles-module__skWmJW__form",
  "heading": "styles-module__skWmJW__heading",
  "headingContainer": "styles-module__skWmJW__headingContainer",
  "icon": "styles-module__skWmJW__icon",
});
